export function queryToString(queryStringObj) {
    return Object.keys(queryStringObj)
        .map(function (prop) {
        return prop + "=" + encodeURIComponent(queryStringObj[prop])
            .replace(/%20/g, '+')
            .replace(/\*/g, '%2A');
    })
        .join('&');
}
//# sourceMappingURL=urlUtils.js.map